module.exports = "/resources/assets/prod/5afe1cbf6c146e8993335d5715210cf6.jpg";